module.exports = __webpack_public_path__ + "img/pass1.9625c5cb.svg";